import { formatCurrency } from './formatCurrency';

const htmlTemplate = (store: any) => {
	return `
        <table width="500" cellspacing="2">
            <tbody>
                <tr>
                    <td>First Name</td>
                    <td>${store.firstName}</td>
                </tr>
                <tr>
                    <td>Last Name</td>
                    <td>${store.lastName}</td>
                </tr>
                <tr>
                    <td>Email Address</td>
                    <td>${store.email}</td>
                </tr>
                <tr>
                    <td>House Address</td>
                    <td>${store.homeAddress}</td>
                </tr>
                <tr>
                    <td colspan="1" style="padding-top: 20px;"><h2>Seller Information</h2></td>
                </tr>
                <tr>
                    <td>Sales Price</td>
                    <td>${formatCurrency(store.salesPrice.raw)}</td>
                </tr>
                <tr>
                    <td>Loan Payoff</td>
                    <td>${formatCurrency(store.loanPayoffs.raw)}</td>
                </tr>
                <tr>
                    <td>Real Estate Commission</td>
                    <td>${store.realEstateCommissionPercent}%</td>
                    <td>${formatCurrency(store.realEstateCommission.raw)}</td>
                </tr>
                <tr>
                    <td colspan="1" style="padding-top: 20px;"><h2>Title Insurance</h2></td>
                </tr>
                <tr>
                    <td>Title Insurance(Owner's policy)</td>
                    <td>${formatCurrency(store.titleInsurance.raw)}</td>
                </tr>
                <tr>
                    <td colspan="1" style="padding-top: 20px;"><h2>Escrow Services</h2></td>
                </tr>
                <tr>
                    <td>Escrow Fee</td>
                    <td>${formatCurrency(store.escrowFee.raw)}</td>
                </tr>
                <tr>
                    <td colspan="1" style="padding-top: 20px;"><h2>Miscellaneous</h2></td>
                </tr>
                <tr>
                    <td>Seller's Contribution</td>
                    <td>${formatCurrency(store.sellersContributions.raw)}</td>
                </tr>
                <tr>
                    <td>${store.other1Label}</td>
                    <td>${formatCurrency(store.other1.raw)}</td>
                </tr>
                <tr>
                    <td>${store.other2Label}</td>
                    <td>${formatCurrency(store.other2.raw)}</td>
                </tr>
                <tr>
                    <td colspan="1" style="padding-top: 20px;"><h2>Totals</h2></td>
                </tr>
                <tr>
                    <td>Estimated Total Costs</td>
                    <td>${formatCurrency(store.estimatedTotalCosts)}</td>
                </tr>
                <tr>
                    <td>Total Loan Payoffs</td>
                    <td>${formatCurrency(store.loanPayoffs.raw)}</td>
                </tr>
                <tr>
                    <td>Estimated Net Proceeds</td>
                    <td>${formatCurrency(store.estimatedNetProceeds)}</td>
                </tr>
            </tbody>
        </table>
    `;
};

export default htmlTemplate;
